import React, { createContext, useEffect, useReducer, useState } from 'react';
import AppReducer from './AppReducer';
import { SET_PERSISTENCE } from './actionTypes';

export const initialState = {
  language: null,
  themeMode: 'light-mode',
  geolocation: null,
  coords: null,
  vin: '',
  reportUrl: '',
  searchId: '',
  registeredTransaction: false,
  userData: null
};

const AppContext = createContext(initialState);

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const state = localStorage.getItem('state');
    if (state) {
      const parsedState = JSON.parse(state);
      dispatch({ type: SET_PERSISTENCE, payload: parsedState });
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <></>
  }

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };
